import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Menu, X } from "lucide-react";
import { loadSession, logout } from "../../services/api";
import { ThemeToggle } from "../ThemeToggle";
import { useSidebar } from "./SidebarContext";

export function Topbar() {
  const navigate = useNavigate();
  const session = loadSession();
  const { toggle, mobileOpen, isMobile } = useSidebar();

  if (!session) return null;
  const initials = session.operator.fullName.split(" ").map((n) => n[0]).slice(0, 2).join("");

  async function onLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <header className="topbar">
      <div className="topbar-title">
        <button
          type="button"
          className="sidebar-toggle"
          onClick={toggle}
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? <X size={18} /> : <Menu size={18} />}
        </button>
        {!isMobile ? <> <span className="eyebrow">Internal</span>
          <span style={{ fontSize: 13, color: "var(--text-dim)" }}>
            Manage tenants, plans, limits, and audit trails.
          </span></> : null}
      </div>
      <div className="topbar-user">
        <ThemeToggle />
        <div className="topbar-avatar">{initials.toUpperCase()}</div>
        <div className="topbar-meta">
          <span className="topbar-name">{session.operator.fullName}</span>
          <span className="topbar-email">{session.operator.email}</span>
        </div>
        <button className="icon-btn" onClick={onLogout} aria-label="Sign out">
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
}
